const darkTiles = ["http://a.tile.stamen.com/toner/{z}/{x}/{y}.png"];
const lightTiles = ["http://a.tile.stamen.com/toner/{z}/{x}/{y}.png"];

export const editorTileset = {
  version: 8,
  sources: {
    "dark-theme": {
      type: "raster",
      tiles: darkTiles,
      tileSize: 256
    }
  },
  layers: [
    {
      id: "dark-theme",
      type: "raster",
      source: "dark-theme",
      minzoom: 0,
      maxzoom: 22
    }
  ],
  glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
};

export const getTrafficCountTileset = theme => ({
  version: 8,
  sources: {
    "dark-theme": {
      type: "raster",
      tiles: darkTiles,
      tileSize: 256
    },
    "light-theme": {
      type: "raster",
      tiles: lightTiles,
      tileSize: 256
    }
  },
  layers: [
    {
      id: "dark-theme",
      type: "raster",
      source: "dark-theme",
      minzoom: 0,
      maxzoom: 22,
      layout: {
        visibility: theme === "dark-theme" ? "visible" : "none"
      }
    },
    {
      id: "light-theme",
      type: "raster",
      source: "light-theme",
      minzoom: 0,
      maxzoom: 22,
      layout: {
        visibility: theme === "light-theme" ? "visible" : "none"
      }
    }
  ],
  glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
});

export const getPublicTransportTileset = theme => ({
  version: 8,
  sources: {
    "dark-theme": {
      type: "raster",
      tiles: darkTiles,
      tileSize: 256
    },
    "light-theme": {
      type: "raster",
      tiles: lightTiles,
      tileSize: 256
    }
  },
  layers: [
    {
      id: "dark-theme",
      type: "raster",
      source: "dark-theme",
      minzoom: 0,
      maxzoom: 22,
      layout: {
        visibility: theme === "dark-theme" ? "visible" : "none"
      }
    },
    {
      id: "light-theme",
      type: "raster",
      source: "light-theme",
      minzoom: 0,
      maxzoom: 22,
      layout: {
        visibility: theme === "light-theme" ? "visible" : "none"
      }
    }
  ],
  glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
});

export const getScenarioModellingTileset = theme => ({
  version: 8,
  sources: {
    "dark-theme": {
      type: "raster",
      tiles: darkTiles,
      tileSize: 256
    },
    "light-theme": {
      type: "raster",
      tiles: lightTiles,
      tileSize: 256
    }
  },
  layers: [
    {
      id: "dark-theme",
      type: "raster",
      source: "dark-theme",
      minzoom: 0,
      maxzoom: 22,
      layout: {
        visibility: theme === "dark-theme" ? "visible" : "none"
      }
    },
    {
      id: "light-theme",
      type: "raster",
      source: "light-theme",
      minzoom: 0,
      maxzoom: 22,
      layout: {
        visibility: theme === "light-theme" ? "visible" : "none"
      }
    }
  ],
  glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
});

export const getEventEditorTileset = theme => ({
  version: 8,
  sources: {
    "dark-theme": {
      type: "raster",
      tiles: darkTiles,
      tileSize: 256
    },
    "light-theme": {
      type: "raster",
      tiles: lightTiles,
      tileSize: 256
    }
  },
  layers: [
    {
      id: "dark-theme",
      type: "raster",
      source: "dark-theme",
      minzoom: 0,
      maxzoom: 22,
      layout: {
        visibility: theme === "dark-theme" ? "visible" : "none"
      }
    },
    {
      id: "light-theme",
      type: "raster",
      source: "light-theme",
      minzoom: 0,
      maxzoom: 22,
      layout: {
        visibility: theme === "light-theme" ? "visible" : "none"
      }
    }
  ],
  glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
});
